import { Api } from '@shared-providers/api.provider';
import { Injectable } from '@angular/core';
import { Provider } from '@shared-providers/Provider';
import { LoadingService } from '@shared-services/loading.service';
import { ITenant } from '@internal-models/tenant.model';
import { IRegisterTenant } from '@shared-models/user.model';

@Injectable({
	providedIn: 'root',
})
export class TenantProvider extends Provider<ITenant> {
	protected readonly url: string = '/tenants';

	constructor(
		protected readonly api: Api,
		protected readonly loadingService: LoadingService
	) {
		super(loadingService);
	}

	public getOne(): Promise<ITenant> {
		return this.process(this.api.get(`${this.url}`), false) as Promise<ITenant>;
	}

	public getIntroDetails(): Promise<Pick<ITenant, 'name' | 'intro'>> {
		return this.process(this.api.get(`${this.url}/intro`), false) as Promise<Pick<ITenant, 'name' | 'intro'>>;
	}

	public register(tenant: IRegisterTenant): Promise<void> {
		return this.process(this.api.post(`${this.url}/register`, tenant)) as unknown as Promise<void>;
	}

	public update(tenant: FormData): Promise<ITenant> {
		return this.process(this.api.put(`${this.url}`, tenant)) as unknown as Promise<ITenant>;
	}

	public hasBeegoPartnerLink(): Promise<boolean> {
		return this.process(this.api.get(`${this.url}/beego-link`), false) as Promise<boolean>;
	}
}
